import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'src/auth/hooks';
import { accessibleCompanies } from '@heyjob-dash/shared/company/onboarding/model';

// A link opens the onboarding of its company once; afterwards the header selector decides the company.
export function useOnboardingCompanySync(companyId) {
  const { user, selectCompany } = useAuthContext();
  const navigate = useNavigate();
  const companies = user?.data?.companies;
  const current = user?.data?.current_company;
  const linked = useRef(null);
  useEffect(() => {
    if (linked.current !== companyId) {
      linked.current = companyId;
      if (String(current) !== String(companyId) && accessibleCompanies(companies).includes(String(companyId))) selectCompany(companyId);
      return;
    }
    if (current != null && String(current) !== String(companyId)) {
      navigate(companies?.[current]?.status === 'onboarding' ? `/onboarding/${current}` : '/', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, current]);
}
